<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YZov4z/tc-custom/9781466846166.jpg?1737776255573" alt="This image is the cover for the book Death at Every Stop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death at Every Stop
      </h1>
      <p class="bookDescription body article font2">
        <p>THE SPREE KILLINGS THAT TERRORIZED THE NATION<br/><br/><b>April 29, 1997--</b>The body of 28-year-old Jeffrey Trail found wrapped in a rug in a Minneapolis apartment. <b>May 3--</b>Fishermen find the body of 33-year-old architect David Madson in Minnesota's East Rush lake. <b>May 4--</b>The tortured body of wealthy 72-year-old real estate investor Lee Miglin found in his garage. <b>May 9--</b>45-year-old caretaker William Reese found in a New Jersey cemetery with a bullet in his head. <b>July 15--</b>World-renowned fashion designer Gianni Versace shot twice in the back of the head and left to die in front of his South Beach mansion.<br/><br/>THE CAT AND MOUSE CHASE THAT GRIPPED THE COUNTRY<br/>The man responsible for these horrific slayings was Andrew Cunanan, a cunning, cold-blooded killer who eluded police for three months until July 23rd, 1997, when, after a harrowing standoff on a Miami houseboat, police found Cunanan inside the boat--dead by his own hand.  But as the tragic crime spree comes to an end, the mystery is just beginning--who was Andrew Cunanan and what led him to savagely murder five men?  What was his relationship to the victims?  And how did a handsome, privileged young man venture so far into the dark side?<br/><br/>THE FINAL ENDING THAT SHOCKED THE WORLD<br/>Described as everything from a flamboyant playboy to a transvestite prostitute to a gold-digging "kept man," Andrew Cunanan has remained an enigma--even in death.  Now, in this searing expose, author Wensley Clarkson examines Cunanan from the inside out, revealing never-before-told facts about his life, including:<br/><br/><b>- The truth about the wife and child he claimed to have had</b><br/><b>- A scandalous affair Cunanan claimed to have had with an older TV star</b><br/><b>- The tragic childhood that sparked his fury</b><br/><b>- How Cunanan starred in gay porno videos</b><br/><b>- Cunanan's deadly obsession with Tom Cruise</b><br/><b>- And much, much, more</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wensley Clarkson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?778ffee7